import * as THREE from 'three';

import { HTMLLabel } from '../html-label';
import AbstractObject from '../../misc/object';

export default class Screw extends AbstractObject {
  
  static minSize = 1;

  static types = {
    LONG_X: 'long-x',
    LONG_Y: 'long-y',
    height: {
      INDENTED: 'indented',
      DEFAULT: 'default'
    }
  };

  static positions = {
    SQUARE: 'SQUARE',
    CIRCLE: 'CIRCLE',
    TRIANGLE: 'TRIANGLE',
    BEND: 'BEND'
  };

  constructor(options) {
    super(options);

    this.name = this.options.name ? `${this.options.name}_${this.options.number}` : `screw_${this.options.number}`;
    this.number = this.options.number;
    this.radius = this.options.radius;

    if (typeof this.options.height === 'number') {
      this.height = this.options.height + (this.options.heightOffset || 0);
    } else {
      throw new TypeError('Screw height is required as number!');
    }

    if (this.options.type === Screw.types.LONG_X || this.options.type === Screw.types.LONG_Y) {
      this.geometry = this.getLongGeometry(this.options.radius, this.height, this.options.type);
    } else {
      const radiusSegments = 64; //this.options.radius * 10;
      this.geometry = new THREE.CylinderGeometry(this.options.radius, this.options.radius, this.height, radiusSegments);
    }

    const material = new THREE.MeshLambertMaterial({
      color: this.options.color || 0x111111
    });

    this.screw = new THREE.Mesh(this.geometry, material);
    this.screw.rotation.z = Math.PI / 2;

    // Prepare mesh
    if (this.options.type === Screw.types.LONG_X || this.options.type === Screw.types.LONG_Y) {
      this.screw.rotation.y = Math.PI / 2;
      this.screw.position.x = this.options.height / -2;

      if (this.options.type === Screw.types.LONG_X) {
        this.screw.rotation.x = Math.PI / -2;
      } else if (this.options.type === Screw.types.LONG_Y) {
        // this.screw.rotation.z = Math.PI / 2;
      }
    }

    this.object.addMesh(this.screw);

    this._bbox = new THREE.Box3(new THREE.Vector3(), new THREE.Vector3());

    // TODO: Only for 2D mode
    // this.addHTML(this.numberLabel.domElement);
  }

  setColor(color) {
    this.screw.material.color.setHex(color);
  }

  setPosition(vector) {
    if (Number.isFinite(+vector.x) && Number.isFinite(+vector.y) && Number.isFinite(+vector.z)) {
      this.position.set(vector.x, vector.y, vector.z);
      this.numberLabel.position.set(-vector.y, -vector.x, vector.z);
    } else {
      throw new Error('Vector should be instance of THREE.Vector3');
    }
  }

  get size() {
    return {
      radius: this.options.radius,
      height: this.options.height
    };
  }

  get bbox() {
    this._bbox.setFromObject(this.screw);
    return this._bbox;
  }

  render(camera, renderer) {
    if (this.numberLabel) {
      this.numberLabel.render(camera, renderer);
    }
  }

  get numberLabel() {
    if (!this._numberLabel) {
      this._numberLabel = new HTMLLabel({
        text: this.number,
        color: "#ffffff",
        bold: true,
        verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
        align: HTMLLabel.types.align.CENTER
      });
    }

    return this._numberLabel;
  }

  getLongGeometry(radius, depth) {
    const height = radius * 3;
    const hafHeight = height / 2;
    const width = radius;
    const hafWidth = -width;

    const shape = new THREE.Shape();
    shape.moveTo(hafWidth, -hafHeight);
    shape.lineTo(hafWidth, hafHeight);
    shape.absarc(width + hafWidth, hafHeight, width, Math.PI, 0, true);
    shape.lineTo(width * 2 + hafWidth, -hafHeight);
    shape.absarc(width + hafWidth, -hafHeight, width, 2 * Math.PI, Math.PI, true);

    const extrudeSettings = {
      depth,
      bevelEnabled: false
    };

    return new THREE.ExtrudeBufferGeometry(shape, extrudeSettings);
  }
  
}



// WEBPACK FOOTER //
// ./src/object-view/objects/screw/screw.js